import React from 'react';
import BackButton from '@/components/BackButton';

const Privacy: React.FC = () => {
  return (
    <div className="min-h-screen bg-background py-12">
      <BackButton />
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto prose prose-slate dark:prose-invert">
          <h1>Privacy Policy</h1>
          <p className="lead">
            Last updated: March 15, 2024
          </p>

          <h2>1. Introduction</h2>
          <p>
            NEXUS Phish ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you use our platform.
          </p>

          <h2>2. Information Collection</h2>
          <p>
            We collect information that you voluntarily provide when using our platform:
          </p>
          <ul>
            <li>Telegram bot tokens and chat IDs for configuration purposes</li>
            <li>Authentication passcodes</li>
            <li>Simulated login credentials during testing</li>
          </ul>

          <h2>3. Use of Information</h2>
          <p>
            The information collected is used solely for:
          </p>
          <ul>
            <li>Operating and maintaining the platform</li>
            <li>Providing the requested simulation services</li>
            <li>Research and educational purposes</li>
            <li>Improving platform security and functionality</li>
          </ul>

          <h2>4. Data Security</h2>
          <p>
            We implement appropriate security measures to protect your information:
          </p>
          <ul>
            <li>Encryption of sensitive data</li>
            <li>Secure authentication mechanisms</li>
            <li>Regular security audits</li>
            <li>Access controls and monitoring</li>
          </ul>

          <h2>5. Data Retention</h2>
          <p>
            We retain collected information only for as long as necessary to provide our services and comply with legal obligations. Users can request data deletion at any time.
          </p>

          <h2>6. Third-Party Services</h2>
          <p>
            We may use third-party services that collect, monitor, and analyze platform usage. These services are bound by their own privacy policies.
          </p>

          <h2>7. Contact Information</h2>
          <p>
            For questions about this Privacy Policy, please contact NEXUSCIPHERGUARD INDIA.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;